import { Tabs } from "antd";
import { useLocation, useNavigate } from "react-router-dom";
import { accessChecker } from "../../../lib/functions";
import Packing from "./Packing";
import PackingRecord from "./PackingRecord";
import Shipping from "../Shipping/Shipping";
import ShippingRecord from "../Shipping/ShippingRecord";

const TatmeenModule = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const params = new URLSearchParams(location.search);
    const activeTab = params.get("tab") || "packing";

    const menuData = [
        {
            label: "Packing",
            key: "packing",
            value: "tatmeen_entry",
            children: <Packing />,
        },
        {
            label: "Packing Record",
            key: "record",
            value: "tatmeen_entry",
            children: <PackingRecord />,
        },
        {
            label: "Shipping",
            key: "shipping",
            value: "tatmeen_entry",
            children: <Shipping />,
        },
        {
            label: "Shipping Record",
            key: "shipping-record",
            value: "tatmeen_entry",
            children: <ShippingRecord />,
        },
        // future Tatmeen-module tabs added here later
    ];

    const filteredMenuData = menuData.filter((menuItem) => accessChecker(menuItem.value));

    return (
        <Tabs
            activeKey={activeTab}
            onChange={(key) => navigate(`/tatmeen?tab=${key}`)}
            type="card"
            size="medium"
            style={{ marginBottom: 32 }}
            items={filteredMenuData}
        />
    );
};

export default TatmeenModule;
